export const appInfoSelector = (state) => state.appInfo;
export const introVideoSelector = (state) => state.appInfo?.introVideo;
